export function initHomeNewsletter() {
  var form = document.getElementById("homeNewsletterForm");
  var alert = document.getElementById("homeNewsletterAlert");
  if (!form || !alert) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var email = (form.email.value || "").trim();
    if (!email) {
      showAlert(alert, "يرجى إدخال بريد إلكتروني صحيح.", "error");
      return;
    }

    var btn = form.querySelector("button[type=submit]");
    if (btn) btn.disabled = true;

    frappe.call({
      method: "frappe.client.insert",
      args: {
        doc: {
          doctype: "Newsletter Subscription",
          email: email,
        },
      },
      callback: function () {
        showAlert(alert, "تم اشتراكك بنجاح! شكراً لك.", "success");
        form.reset();
        if (btn) btn.disabled = false;
      },
      error: function () {
        showAlert(alert, "حدث خطأ، يرجى المحاولة مرة أخرى.", "error");
        if (btn) btn.disabled = false;
      },
    });
  });
}

function showAlert(el, msg, type) {
  el.textContent = msg;
  el.style.background = type === "success"
    ? "rgba(22,163,74,.12)"
    : "rgba(220,38,38,.10)";
  el.style.borderColor = type === "success"
    ? "rgba(22,163,74,.25)"
    : "rgba(220,38,38,.25)";
  el.removeAttribute("hidden");

  setTimeout(function () { el.setAttribute("hidden", ""); }, 5000);
}
